import React from 'react';
import { NavLink } from 'react-router-dom';



import {
  DashboardIcon,
  InsightsIcon,
  ReportsIcon,
} from '../../../components/ui/AppIcon';

import {
  DirectionIcon,
  MovesIcon,
  PlanIcon,
  SprintIcon,
  TrackerIcon,
} from '../../../components/ui/AppIcon';



const ICON_BY_SLUG = {
  
  'idioms': {
    'models': InsightsIcon,
    'reports': ReportsIcon,
  },
  
  'models': {
    'directional-strategies': DirectionIcon,
    'strat-plans': PlanIcon,
    'sprint-packs': SprintIcon,
    'strat-moves': MovesIcon,
    'stat-tracker-entries': TrackerIcon,
    'people': PlanIcon,
    'organizations': PlanIcon,
    'positions': PlanIcon,
    'jobs': PlanIcon,
  }

};


const Factory = ( model, rolePermissions, user, setIsSidebarOpen, metadata ) => {
  return model.domain.map((item) => {
  
    const Icons = ICON_BY_SLUG[item.slug];
    
    return (
      <>
        <p className="sidebar-nav-label">{item.section}</p>

        {metadata[ item.slug ].map((item) => {

          if ( user && ! rolePermissions.hasPermission(user, 'content.view') ) {
            return '';
          }

          const NavItemIcon = Icons[item.slug] || PlanIcon;

          return (
            <NavLink
              className={({ isActive }) => `sidebar-link${isActive ? ' is-active' : ''}`}
              key={'/' + item.slug}
              onClick={() => setIsSidebarOpen(false)}
              to={'/' + item.slug}
            >
              <NavItemIcon className="nav-icon" />
              <span>{item.plural}</span>
            </NavLink>
          );
        })}
      </>
    );
  });
};

export default Factory;

